/* ==========================================================================
   Simaru-Warenkorb im Maison-Afford-Stil
   - Slide-in-Drawer (rechts) bzw. Warenkorbseite, beide ueber die
     Section Rendering API gerendert (Liquid = einzige Quelle der Wahrheit)
   - Mengen aendern / entfernen / hinzufuegen ohne Neuladen
   - Neue Artikel werden markiert und in den sichtbaren Bereich gescrollt
   - Stufen-Leiste (Punkte auf Linie): neue Stufe ploppt auf, naechstes
     3er-Fenster rollt rein, Konfetti bei jedem Gratis-Artikel / Geschenk
   - Hauptzeile blendet bei Aenderung neu ein, Hinweiszeile wechselt alle
     paar Sekunden (Antippen = naechster Hinweis)
   - Geschenk-Stufe: Geschenk wird automatisch hinzugefuegt/entfernt
   - Empfehlungs-Karussell (scroll-snap, Pfeile, Maus-Ziehen, Fortschritt)
   - Scroll-Schatten, Body-Scroll-Sperre, Wischen zum Schliessen, ESC
   ========================================================================== */
(function () {
  'use strict'
  if (window.SimCart) return

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'

  // Regeln fuer das Empfehlungs-Karussell (aus dem bisherigen Warenkorb uebernommen)
  var UPSELL = {
    limit: 8,
    pageSize: 50,
    // Tabak-Zubehoer (Tabakbefeuchter, Extra Verschluss - Set) nur zu einer Tabaktasche
    tobaccoIds: ['6810087391417', '15646593188105'],
    pouch: /tabaktasche|tabakbeutel|drehertasche/i,
    // Service-Produkte nie vorschlagen
    exclude: ['gravur', 'item personalization']
  }

  function qs(el, sel) { return el ? el.querySelector(sel) : null }
  function qsa(el, sel) { return el ? Array.prototype.slice.call(el.querySelectorAll(sel)) : [] }

  function SimCart() {
    this.drawer = document.querySelector('sim-cart-drawer')
    this.page = document.querySelector('sim-cart-page')
    this.hosts = [this.drawer, this.page].filter(Boolean)
    this.isOpen = false
    this.pending = 0
    this.noteOpen = false
    this.upsell = { key: null, node: null, title: '', scroll: 0, run: 0 }
    this.tickIdx = 0
    this.tickTimer = null
    this.bind()
    this.afterRender(null)
    this.startTicker()
  }

  SimCart.prototype.sectionIds = function () {
    return this.hosts.map(function (h) { return h.dataset.sectionId })
  }

  SimCart.prototype.cartEl = function () {
    for (var i = 0; i < this.hosts.length; i++) {
      var c = qs(this.hosts[i], '[data-sim-cart]')
      if (c) return c
    }
    return null
  }

  /* ---------------------------------------------------------------- Events */
  SimCart.prototype.bind = function () {
    var self = this

    document.addEventListener('click', function (e) {
      var t = e.target

      // Warenkorb-Symbol im Header oeffnet den Drawer
      var trigger = t.closest('#HeaderCartTrigger, [data-sim-cart-open]')
      if (trigger && self.drawer) {
        e.preventDefault()
        self.open()
        return
      }

      if (!t.closest('sim-cart-drawer, sim-cart-page')) return

      if (t.closest('[data-sim-close]')) {
        e.preventDefault()
        self.close()
        return
      }

      var qtyBtn = t.closest('[data-sim-qty]')
      if (qtyBtn) {
        e.preventDefault()
        var line = qtyBtn.closest('[data-key]')
        if (!line) return
        if (qtyBtn.dataset.simQty === '0') line.classList.add('is-removing')
        self.change(line.dataset.key, parseInt(qtyBtn.dataset.simQty, 10))
        return
      }

      var addBtn = t.closest('[data-sim-add]')
      if (addBtn) {
        e.preventDefault()
        var card = addBtn.closest('.sim-up')
        if (card) {
          self.lastAddName = card.dataset.title + (card.dataset.variantTitle ? ' (' + card.dataset.variantTitle + ')' : '')
        }
        if (addBtn.dataset.variantId) self.addFromCard(addBtn.dataset.variantId, card, addBtn)
        return
      }

      if (t.closest('[data-sim-tick]')) {
        self.tickStep()
        self.startTicker()
        return
      }

      var noteToggle = t.closest('[data-sim-note-toggle]')
      if (noteToggle) {
        e.preventDefault()
        self.noteOpen = !self.noteOpen
        self.applyNoteState()
        if (self.noteOpen) {
          var ta = qs(noteToggle.parentNode, 'textarea')
          if (ta) ta.focus()
        }
        return
      }

      var arrow = t.closest('[data-sim-up-prev], [data-sim-up-next]')
      if (arrow) {
        e.preventDefault()
        var track = qs(arrow.closest('.sim-ups'), '[data-sim-up-track]')
        if (!track) return
        var dir = arrow.hasAttribute('data-sim-up-next') ? 1 : -1
        var cardEl = qs(track, '.sim-up')
        var stepW = cardEl ? cardEl.getBoundingClientRect().width + 12 : track.clientWidth * 0.8
        track.scrollBy({ left: dir * Math.max(stepW, Math.floor(track.clientWidth / stepW) * stepW), behavior: 'smooth' })
      }
    })

    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-sim-note]')) {
        fetch(ROOT + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: e.target.value })
        }).catch(function () {})
      }
    })

    document.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-sim-checkout-form]')) return
      var btn = qs(e.target, '[name="checkout"]')
      if (btn) btn.classList.add('is-loading')
    })

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.isOpen) self.close()
      if (e.key === 'Tab' && self.isOpen) self.trapFocus(e)
    })

    // Artikel wurde vom Theme hinzugefuegt (Produktseite, Quick-Add, ...)
    document.addEventListener('ajaxProduct:added', function () { self.onExternalAdd() })
    document.addEventListener('sim-cart:refresh', function () { self.refresh() })
    document.addEventListener('cart:open', function () { self.open() })

    // Zurueck-Navigation (bfcache): Warenkorb aktualisieren
    window.addEventListener('pageshow', function (e) { if (e.persisted) self.refresh() })

    this.bindSwipe()
  }

  SimCart.prototype.bindSwipe = function () {
    if (!this.drawer) return
    var self = this
    var panel = qs(this.drawer, '.sim-drawer__panel')
    var sx = null, sy = 0, dx = 0, horizontal = null

    panel.addEventListener('touchstart', function (e) {
      if (e.target.closest('[data-sim-up-track], textarea')) { sx = null; return }
      sx = e.touches[0].clientX
      sy = e.touches[0].clientY
      dx = 0
      horizontal = null
    }, { passive: true })

    panel.addEventListener('touchmove', function (e) {
      if (sx === null) return
      var x = e.touches[0].clientX - sx
      var y = e.touches[0].clientY - sy
      if (horizontal === null && (Math.abs(x) > 8 || Math.abs(y) > 8)) horizontal = Math.abs(x) > Math.abs(y)
      if (!horizontal) return
      dx = Math.max(0, x)
      panel.style.transition = 'none'
      panel.style.transform = 'translateX(' + dx + 'px)'
    }, { passive: true })

    panel.addEventListener('touchend', function () {
      if (sx === null) return
      panel.style.transition = ''
      panel.style.transform = ''
      if (horizontal && dx > 90) self.close()
      sx = null
    })
  }

  /* -------------------------------------------------------- Oeffnen/Schliessen */
  SimCart.prototype.open = function () {
    if (!this.drawer) {
      if (!this.page) window.location.href = ROOT + 'cart'
      return
    }
    if (this.isOpen) return
    this.isOpen = true
    this.lastFocus = document.activeElement

    var sbw = window.innerWidth - document.documentElement.clientWidth
    document.documentElement.style.setProperty('--sim-sbw', sbw + 'px')
    document.documentElement.classList.add('sim-cart-lock')

    this.drawer.classList.add('is-open')
    this.drawer.setAttribute('aria-hidden', 'false')

    var panel = qs(this.drawer, '.sim-drawer__panel')
    window.requestAnimationFrame(function () { panel.focus({ preventScroll: true }) })

    this.updateScrollState()
    this.ensureUpsell()
    document.dispatchEvent(new CustomEvent('sim-cart:opened'))
  }

  SimCart.prototype.close = function () {
    if (!this.drawer || !this.isOpen) return
    this.isOpen = false
    this.drawer.classList.remove('is-open')
    this.drawer.setAttribute('aria-hidden', 'true')
    document.documentElement.classList.remove('sim-cart-lock')
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true })
    document.dispatchEvent(new CustomEvent('sim-cart:closed'))
  }

  SimCart.prototype.trapFocus = function (e) {
    var panel = qs(this.drawer, '.sim-drawer__panel')
    var items = qsa(panel, 'a[href], button:not([disabled]), textarea, select, input').filter(function (el) {
      return el.offsetParent !== null
    })
    if (!items.length) return
    var first = items[0]
    var last = items[items.length - 1]
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault()
      last.focus()
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault()
      first.focus()
    }
  }

  /* ------------------------------------------------------------ Aenderungen */
  SimCart.prototype.snapshot = function () {
    var c = this.cartEl()
    var lines = {}
    qsa(c, '[data-key]').forEach(function (l) { lines[l.dataset.key] = parseInt(l.dataset.qty, 10) || 0 })
    return {
      lines: lines,
      level: c ? parseInt(c.dataset.rewardLevel, 10) || 0 : 0,
      count: c ? parseInt(c.dataset.count, 10) || 0 : 0,
      filled: c ? parseInt(c.dataset.filled, 10) || 0 : 0,
      window: c ? c.dataset.window || '' : '',
      msg: (qs(c, '[data-sim-msg]') || {}).textContent || ''
    }
  }

  SimCart.prototype.setLoading = function (on) {
    this.pending = Math.max(0, this.pending + (on ? 1 : -1))
    var c = this.cartEl()
    if (c) c.classList.toggle('is-loading', this.pending > 0)
  }

  SimCart.prototype.post = function (url, payload) {
    var body = Object.assign({}, payload, {
      sections: this.sectionIds(),
      sections_url: window.location.pathname
    })
    return fetch(ROOT + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data } })
    })
  }

  SimCart.prototype.mutate = function (url, payload) {
    var self = this
    var before = this.snapshot()
    this.setLoading(true)
    return this.post(url, payload)
      .then(function (r) {
        if (!r.ok || r.data.status) {
          self.toast(r.data.description || r.data.message || 'Das hat leider nicht geklappt.', true)
          return self.refresh(before).then(function () { return null })
        }
        if (r.data.sections) self.render(r.data.sections, before)
        else return self.refresh(before).then(function () { return r.data })
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: r.data } }))
        return r.data
      })
      .catch(function () {
        self.toast('Verbindungsfehler – bitte versuche es noch einmal.', true)
        return null
      })
      .finally(function () { self.setLoading(false) })
  }

  SimCart.prototype.change = function (key, qty) {
    return this.mutate('cart/change.js', { id: key, quantity: Math.max(0, qty) })
  }

  SimCart.prototype.add = function (variantId, qty) {
    return this.mutate('cart/add.js', { items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
  }

  SimCart.prototype.addFromCard = function (variantId, card, btn) {
    if (btn.classList.contains('is-loading') || (card && card.classList.contains('is-added'))) return
    btn.classList.add('is-loading')
    this.add(variantId, 1).then(function (data) {
      btn.classList.remove('is-loading')
      if (data && card) card.classList.add('is-added')
    })
  }

  SimCart.prototype.refresh = function (before) {
    var self = this
    var ids = this.sectionIds()
    if (!ids.length) return Promise.resolve()
    before = before || this.snapshot()
    var url = window.location.pathname + '?sections=' + encodeURIComponent(ids.join(',')) + '&_=' + Date.now()
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json() })
      .then(function (sections) { self.render(sections, before) })
      .catch(function () {})
  }

  SimCart.prototype.onExternalAdd = function () {
    var self = this
    var before = this.snapshot()
    this.refresh(before).then(function () { self.open() })
  }

  /* -------------------------------------------------------------- Rendern */
  SimCart.prototype.render = function (sections, before) {
    var self = this
    this.hosts.forEach(function (host) {
      var html = sections[host.dataset.sectionId]
      if (!html) return
      var doc = new DOMParser().parseFromString(html, 'text/html')
      var fresh = doc.querySelector('[data-sim-cart-root]')
      var target = qs(host, '[data-sim-cart-root]')
      if (!fresh || !target) return

      var scroller = qs(target, '[data-sim-scroll]')
      var scrollTop = scroller ? scroller.scrollTop : 0
      var noteEl = qs(target, '[data-sim-note]')
      var noteVal = noteEl ? noteEl.value : null
      // Breite der Fortschrittsbalken merken, damit sie zum neuen Wert "wachsen"
      var bars = ['.sim-rw__bar']
      var oldWidths = bars.map(function (sel) {
        var el = qs(target, sel)
        return el ? el.style.width : null
      })

      target.innerHTML = fresh.innerHTML

      bars.forEach(function (sel, i) {
        var el = qs(target, sel)
        if (!el || oldWidths[i] === null || oldWidths[i] === el.style.width) return
        var to = el.style.width
        el.style.width = oldWidths[i]
        void el.offsetWidth
        el.style.width = to
      })

      var newScroller = qs(target, '[data-sim-scroll]')
      if (newScroller) newScroller.scrollTop = scrollTop
      var newNote = qs(target, '[data-sim-note]')
      if (newNote && noteVal !== null) newNote.value = noteVal
    })
    if (this.pending > 0) {
      var c = this.cartEl()
      if (c) c.classList.add('is-loading')
    }
    if (this.page && window.Shopify && Shopify.StorefrontExpressButtons) {
      try { Shopify.StorefrontExpressButtons.initialize() } catch (e) {}
    }
    this.afterRender(before)
  }

  SimCart.prototype.afterRender = function (before) {
    var c = this.cartEl()
    if (!c) return
    var now = this.snapshot()

    this.updateBubble(now.count)
    this.applyTick(false)
    this.applyNoteState()
    this.bindScroll()
    this.ensureUpsell()

    if (!before) { this.syncGift(); return }

    // Neu hinzugefuegte / erhoehte Positionen markieren und anzeigen
    var added = []
    Object.keys(now.lines).forEach(function (key) {
      if (!(key in before.lines) || now.lines[key] > before.lines[key]) added.push(key)
    })
    var firstNew = null
    var giftAdded = false
    added.forEach(function (key) {
      var line = qs(c, '[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]')
      if (!line) return
      line.classList.add('is-new')
      if (line.hasAttribute('data-gift')) giftAdded = true
      if (!firstNew) firstNew = line
    })
    if (firstNew) this.scrollToLine(firstNew)
    if (giftAdded) this.toast('🎁 Dein Geschenk liegt im Warenkorb')
    else if (added.length === 1 && now.count > before.count && this.lastAddName) this.toast('✓ ' + this.lastAddName + ' hinzugefügt')
    else if (added.length && now.count > before.count) this.toast('✓ Zum Warenkorb hinzugefügt')

    this.lastAddName = ''

    // Hauptzeile hat sich geaendert: neu einblenden
    if (now.msg !== before.msg) {
      var msg = qs(c, '[data-sim-msg]')
      if (msg) msg.classList.add('is-swap')
    }
    // Hinweiszeile nach jeder Aenderung wieder vorne beginnen (Versand zuerst)
    if (now.count !== before.count) {
      this.tickIdx = 0
      this.applyTick(false)
      this.startTicker()
    }

    // Stufen-Leiste: neue Stufe hervorheben bzw. ins naechste Fenster rollen
    var steps = qs(c, '[data-sim-steps]')
    if (steps) {
      if (now.window !== before.window && before.window) steps.classList.add('is-roll')
      else if (now.filled > before.filled) {
        var latest = qs(steps, '.is-latest')
        if (latest) latest.classList.add('is-pop')
      }
    }

    // Neue Stufe erreicht?
    if (now.level > before.level) this.celebrate(c)

    this.syncGift()
  }

  // Geschenk-Stufe: Geschenk automatisch hinzufuegen bzw. wieder entfernen
  SimCart.prototype.syncGift = function () {
    var c = this.cartEl()
    if (!c || this.giftBusy || this.giftDisabled) return
    var variant = c.dataset.giftVariant
    if (!variant) return
    var ok = c.dataset.giftOk === 'true'
    var key = c.dataset.giftKey
    var qty = parseInt(c.dataset.giftQty, 10) || 0
    var self = this
    var job = null
    if (ok && !key) {
      job = this.mutate('cart/add.js', { items: [{ id: parseInt(variant, 10), quantity: 1, properties: { _sim_gift: '1' } }] })
    } else if (!ok && key) {
      job = this.change(key, 0)
    } else if (ok && key && qty > 1) {
      job = this.change(key, 1)
    }
    if (!job) return
    this.giftBusy = true
    job.then(function (data) {
      self.giftBusy = false
      if (!data) self.giftDisabled = true
    })
  }

  SimCart.prototype.scrollToLine = function (line) {
    var scroller = line.closest('[data-sim-scroll]')
    if (scroller) {
      var top = line.offsetTop - 12
      if (top < scroller.scrollTop || top + line.offsetHeight > scroller.scrollTop + scroller.clientHeight) {
        scroller.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
      }
    } else if (this.page) {
      var r = line.getBoundingClientRect()
      if (r.top < 80 || r.bottom > window.innerHeight) {
        window.scrollTo({ top: window.pageYOffset + r.top - 120, behavior: 'smooth' })
      }
    }
  }

  SimCart.prototype.updateBubble = function (count) {
    qsa(document, '.cart-link__bubble-num').forEach(function (el) { el.textContent = count })
    qsa(document, '.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', count > 0)
    })
  }

  SimCart.prototype.applyNoteState = function () {
    var self = this
    this.hosts.forEach(function (host) {
      var wrap = qs(host, '[data-sim-note-wrap]')
      if (!wrap) return
      wrap.classList.toggle('is-open', self.noteOpen)
      var btn = qs(wrap, '[data-sim-note-toggle]')
      if (btn) btn.setAttribute('aria-expanded', self.noteOpen ? 'true' : 'false')
    })
  }

  SimCart.prototype.bindScroll = function () {
    this.hosts.forEach(function (host) {
      var scroller = qs(host, '[data-sim-scroll]')
      var c = qs(host, '[data-sim-cart]')
      if (!scroller || !c) return
      var update = function () {
        c.classList.toggle('is-scrolled', scroller.scrollTop > 4)
        c.classList.toggle('has-more', scroller.scrollTop + scroller.clientHeight < scroller.scrollHeight - 4)
      }
      scroller.addEventListener('scroll', update, { passive: true })
      qsa(scroller, 'img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', update, { once: true })
      })
      update()
    })
  }

  SimCart.prototype.updateScrollState = function () {
    this.hosts.forEach(function (host) {
      var s = qs(host, '[data-sim-scroll]')
      if (s) s.dispatchEvent(new Event('scroll'))
    })
  }

  /* -------------------------------------------------- Wechselnde Hinweise */
  SimCart.prototype.startTicker = function () {
    var self = this
    if (this.tickTimer) clearInterval(this.tickTimer)
    this.tickTimer = setInterval(function () { self.tickStep() }, 4000)
  }

  SimCart.prototype.tickStep = function () {
    if (document.hidden) return
    if (this.drawer && !this.isOpen && !this.page) return
    this.tickIdx++
    this.applyTick(true)
  }

  SimCart.prototype.applyTick = function (animate) {
    var idx = this.tickIdx
    this.hosts.forEach(function (host) {
      var box = qs(host, '[data-sim-tick]')
      if (!box) return
      var items = qsa(box, '.sim-tick__item')
      if (!items.length) return
      var target = items[idx % items.length]
      items.forEach(function (el) {
        if (el === target) return
        if (animate && el.classList.contains('is-on')) {
          el.classList.remove('is-on')
          el.classList.add('is-out')
          setTimeout(function () { el.classList.remove('is-out') }, 450)
        } else if (!animate) {
          el.classList.remove('is-on', 'is-out')
        }
      })
      target.classList.remove('is-out')
      target.classList.add('is-on')
    })
  }

  /* ------------------------------------------------------- Rueckmeldungen */
  SimCart.prototype.toast = function (text, isError) {
    var host = this.isOpen ? qs(this.drawer, '.sim-drawer__panel') : (this.page || document.body)
    var old = qs(host, '.sim-toast')
    if (old) old.remove()
    var el = document.createElement('div')
    el.className = 'sim-toast' + (isError ? ' is-error' : '') + (host === this.page ? ' is-fixed' : '')
    el.setAttribute('role', 'status')
    el.textContent = text
    host.appendChild(el)
    window.requestAnimationFrame(function () { el.classList.add('is-visible') })
    setTimeout(function () {
      el.classList.remove('is-visible')
      setTimeout(function () { el.remove() }, 300)
    }, isError ? 3500 : 2000)
  }

  SimCart.prototype.celebrate = function (c) {
    var box = qs(c, '[data-sim-rewards]')
    if (!box) return
    box.classList.add('is-celebrate')
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setTimeout(function () { box.classList.remove('is-celebrate') }, 1200)
      return
    }
    var colors = ['#f2c53d', '#0f2624', '#d75d43', '#2e7d32', '#e9dcc0']
    var wrap = document.createElement('div')
    wrap.className = 'sim-confetti'
    wrap.setAttribute('aria-hidden', 'true')
    for (var i = 0; i < 28; i++) {
      var p = document.createElement('i')
      p.style.left = Math.random() * 100 + '%'
      p.style.background = colors[i % colors.length]
      p.style.animationDelay = Math.random() * 0.25 + 's'
      p.style.setProperty('--x', (Math.random() * 80 - 40) + 'px')
      p.style.setProperty('--r', (Math.random() * 540 - 270) + 'deg')
      wrap.appendChild(p)
    }
    box.appendChild(wrap)
    setTimeout(function () {
      wrap.remove()
      box.classList.remove('is-celebrate')
    }, 1600)
  }

  /* ------------------------------------------------- Empfehlungs-Karussell */
  SimCart.prototype.cartProducts = function () {
    var c = this.cartEl()
    var ids = []
    var hasPouch = false
    qsa(c, '[data-key]').forEach(function (l) {
      var id = l.dataset.productId
      if (ids.indexOf(id) < 0) ids.push(id)
      if (UPSELL.pouch.test(l.dataset.title || '') && UPSELL.tobaccoIds.indexOf(id) < 0) hasPouch = true
    })
    return { ids: ids, hasPouch: hasPouch }
  }

  SimCart.prototype.fetchCards = function (url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : '' })
      .then(function (html) {
        var d = document.createElement('div')
        d.innerHTML = html
        return qsa(d, '.sim-up')
      })
      .catch(function () { return [] })
  }

  SimCart.prototype.ensureUpsell = function () {
    var c = this.cartEl()
    if (!c) return
    // Drawer zu? Dann erst beim Oeffnen laden (spart Requests)
    if (this.drawer && !this.isOpen && !this.page) {
      this.mountUpsell()
      return
    }
    var info = this.cartProducts()
    var key = info.ids.join(',') || 'empty'
    if (this.upsell.key === key) {
      this.mountUpsell()
      return
    }
    this.upsell.key = key
    var run = ++this.upsell.run
    var self = this
    this.buildUpsell(info).then(function (res) {
      if (run !== self.upsell.run) return
      self.upsell.node = res.cards.length ? res.cards : null
      self.upsell.title = res.title
      self.upsell.scroll = 0
      self.mountUpsell()
    })
  }

  SimCart.prototype.buildUpsell = function (info) {
    var self = this
    var inCart = info.ids
    var c = this.cartEl()
    var shopCount = c ? parseInt(c.dataset.shopProducts, 10) || 50 : 50

    function blocked(el) {
      var id = el.dataset.productId
      var title = (el.dataset.title || '').toLowerCase()
      if (inCart.indexOf(id) > -1) return true
      if (UPSELL.exclude.indexOf(title) > -1) return true
      if (el.dataset.available !== 'true') return true
      if (!info.hasPouch && UPSELL.tobaccoIds.indexOf(id) > -1) return true
      return false
    }

    var base = ROOT + 'recommendations/products?section_id=sim-cart-upsell&limit=10&product_id='
    var requests = inCart.slice(0, 3).map(function (id) {
      return self.fetchCards(base + id + '&intent=complementary').then(function (list) {
        return list.length ? list : self.fetchCards(base + id + '&intent=related')
      })
    })

    return Promise.all(requests).then(function (lists) {
      var picked = []
      var seen = {}
      var ptr = lists.map(function () { return 0 })
      var progress = true
      // Abwechselnd aus den Vorschlaegen je Warenkorb-Artikel waehlen
      while (picked.length < UPSELL.limit && progress) {
        progress = false
        for (var li = 0; li < lists.length && picked.length < UPSELL.limit; li++) {
          while (ptr[li] < lists[li].length) {
            var el = lists[li][ptr[li]++]
            if (!seen[el.dataset.productId] && !blocked(el)) {
              seen[el.dataset.productId] = true
              picked.push(el)
              progress = true
              break
            }
          }
        }
      }
      var title = inCart.length ? 'Das passt perfekt dazu' : 'Beliebt bei unseren Kunden'
      if (picked.length >= UPSELL.limit) return { cards: picked, title: title }

      // Rest mit Zufallsprodukten aus dem ganzen Shop auffuellen
      var pages = Math.max(1, Math.ceil(shopCount / UPSELL.pageSize))
      var page = 1 + Math.floor(Math.random() * pages)
      return self.fetchCards(ROOT + 'collections/all?section_id=sim-cart-upsell&page=' + page).then(function (pool) {
        pool = pool.filter(function (el) {
          var pid = el.dataset.productId
          return !seen[pid] && !blocked(el) && UPSELL.tobaccoIds.indexOf(pid) < 0
        })
        for (var i = pool.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1))
          var tmp = pool[i]; pool[i] = pool[j]; pool[j] = tmp
        }
        return { cards: picked.concat(pool.slice(0, UPSELL.limit - picked.length)), title: title }
      })
    })
  }

  SimCart.prototype.mountUpsell = function () {
    var self = this
    this.hosts.forEach(function (host) {
      var slot = qs(host, '[data-sim-upsell-slot]')
      if (!slot) return
      if (!self.upsell.node) { slot.innerHTML = ''; return }
      var existing = qs(slot, '.sim-ups')
      if (existing && existing.dataset.key === self.upsell.key) { self.initCarousel(existing); return }

      var inCart = self.cartProducts().ids
      var cards = self.upsell.node.filter(function (card) { return inCart.indexOf(card.dataset.productId) < 0 })
      if (!cards.length) { slot.innerHTML = ''; return }

      var wrap = document.createElement('div')
      wrap.className = 'sim-ups'
      wrap.dataset.key = self.upsell.key
      wrap.innerHTML =
        '<div class="sim-ups__head">' +
          '<p class="sim-ups__title"></p>' +
          '<div class="sim-ups__nav">' +
            '<button type="button" class="sim-ups__arrow" data-sim-up-prev aria-label="Zurück">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.2"/></svg></button>' +
            '<button type="button" class="sim-ups__arrow" data-sim-up-next aria-label="Weiter">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.2"/></svg></button>' +
          '</div>' +
        '</div>' +
        '<div class="sim-ups__track" data-sim-up-track></div>' +
        '<div class="sim-ups__progress"><span data-sim-up-bar></span></div>'
      qs(wrap, '.sim-ups__title').textContent = self.upsell.title
      var track = qs(wrap, '[data-sim-up-track]')
      cards.forEach(function (card) { track.appendChild(card.cloneNode(true)) })
      slot.innerHTML = ''
      slot.appendChild(wrap)
      self.initCarousel(wrap)
    })
  }

  SimCart.prototype.initCarousel = function (wrap) {
    if (wrap.dataset.ready) return
    wrap.dataset.ready = '1'
    var self = this
    var track = qs(wrap, '[data-sim-up-track]')
    var prev = qs(wrap, '[data-sim-up-prev]')
    var next = qs(wrap, '[data-sim-up-next]')
    var bar = qs(wrap, '[data-sim-up-bar]')

    var update = function () {
      var max = track.scrollWidth - track.clientWidth
      prev.disabled = track.scrollLeft <= 2
      next.disabled = track.scrollLeft >= max - 2
      wrap.classList.toggle('is-static', max <= 2)
      var visible = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1
      var pos = max > 0 ? track.scrollLeft / max : 0
      bar.style.width = Math.max(12, visible * 100) + '%'
      bar.style.transform = 'translateX(' + (pos * (100 / Math.max(visible, 0.01) - 100)) + '%)'
      self.upsell.scroll = track.scrollLeft
    }
    track.addEventListener('scroll', update, { passive: true })
    window.addEventListener('resize', update)
    qsa(track, 'img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', update, { once: true })
    })
    track.scrollLeft = this.upsell.scroll || 0
    update()

    // Mit der Maus ziehen (Desktop)
    var down = false, moved = false, startX = 0, startL = 0
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return
      if (e.target.closest('select, button')) return
      down = true; moved = false; startX = e.clientX; startL = track.scrollLeft
    })
    track.addEventListener('pointermove', function (e) {
      if (!down) return
      var dx = e.clientX - startX
      if (!moved && Math.abs(dx) > 6) {
        moved = true
        track.classList.add('is-dragging')
        try { track.setPointerCapture(e.pointerId) } catch (err) {}
      }
      if (moved) track.scrollLeft = startL - dx
    })
    var end = function () {
      if (!down) return
      down = false
      track.classList.remove('is-dragging')
    }
    track.addEventListener('pointerup', end)
    track.addEventListener('pointercancel', end)
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false }
    }, true)
  }

  window.SimCart = new SimCart()
})()
